export default "__VITE_ASSET__B2R0q8MY__"